import { StyleSheet } from 'aphrodite';
import { brandSecondary, charmGray, header, navigation } from '../../../../web/styles/colors';
import { CssSelectors, Fonts } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	addMediaWrap: {
		...CssSelectors.allDescendants(
			{
				display: 'block',
				fontSize: 14,
				color: charmGray,
			},
			'.emoji-label-container label'
		),
		...CssSelectors.allDescendants(
			{
				display: 'block',
				fontSize: 14,
				color: charmGray,
			},
			'.add-media-container label'
		),
	},
	bodyEditor: {
		...CssSelectors.allDescendants(
			{
				overflow: 'inherit',
			},
			'.tox.tox-tinymce'
		),
		...CssSelectors.allDescendants(
			{
				overflow: 'inherit',
			},
			'.tox.tox-tinymce .tox-editor-container'
		),
		...CssSelectors.allDescendants(
			{
				background: '#fff',
				borderBottom: '1px solid #ccc',
				position: 'sticky',
				top: 0,
				zIndex: 1,
			},
			'.tox.tox-tinymce .tox-editor-container .tox-editor-header'
		),
	},
	bodyField: {
		border: '1px solid #ccc',
		borderRadius: 3,
		height: 400,
		marginBottom: 10,
		overflowX: 'hidden',
		overflowY: 'auto',
		width: '100%',
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	buttonLink: {
		background: '#00AAE8',
		borderRadius: 3,
		color: 'white',
		display: 'flex',
		fontFamily: Fonts.lexend,
		marginLeft: 6,
		padding: 4,
	},
	container: {
		boxSizing: 'border-box',
		overflowY: 'auto',
		padding: '0 20px 35px',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
	containerInner: {
		width: '100%',
		maxWidth: 830,
		paddingBottom: 34,
	},
	dayPickerPopoverContent: {
		background: '#fff',
		boxSizing: 'border-box',
		padding: '10px 0',
	},
	dayPickerPopoverFooter: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
	},
	dayPickerPopoverHeader: {
		boxSizing: 'border-box',
		padding: '0 20px',
		textAlign: 'right',
	},
	dayPickerPopoverTime: {
		margin: '10px 0',
		textAlign: 'center',
	},
	dayPickerPopoverTimeDropDown: {
		margin: 'auto',
		...CssSelectors.allChildren(
			{
				minWidth: 120,
			},
			'.select-box-menu'
		),
	},
	dayPickerPopoverTimeDropdownOption: {
		fontSize: 14,
	},
	dayPickerPopoverTimeDropdownTrigger: {
		fontSize: 14,
		height: 'auto',
		width: 108,
	},
	editor: {
		background: '#F9F9F9',
		border: '1px solid #ccc',
		height: 150,
		margin: '12px 0',
		width: '100%',
	},
	emailTextField: {
		width: 300,
		...CssSelectors.allChildren(
			{
				'::placeholder': {
					color: header,
					fontSize: 12,
				},
			},
			'input'
		),
	},
	expirationContainer: {
		height: 40,
	},
	expirationDateInput: {
		pointerEvents: 'none',
		width: 110,
	},
	feature: {
		color: brandSecondary,
		fontSize: 12,
		paddingBottom: 4,
		paddingTop: 4,
	},
	featureContainer: {
		margin: '4px 0',
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	fullWidthTextField: {
		marginBottom: 20,
		...CssSelectors.allChildren(
			{
				'::placeholder': {
					color: header,
					fontSize: 12,
				},
			},
			'input'
		),
	},
	modalContainer: {
		width: 600,
		...CssSelectors.allChildren(
			{
				maxHeight: 600,
				overflow: 'scroll',
			},
			'div'
		),
	},
	optionContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 20,
	},
	searchAnchor: {
		width: 300,
	},
	searchBox: {
		borderRadius: 3,
		display: 'inline-block',
		fontSize: 14,
		marginRight: 10,
		outline: 'none',
		verticalAlign: 'middle',
		...CssSelectors.allChildren(
			{
				'::placeholder': {
					color: 'white',
				},
				color: '#FFF',
			},
			'input'
		),
	},
	searchIcon: {
		marginRight: 6,
	},
	sectionLine: {
		borderTop: '1px solid #D3DBDE',
		marginTop: 72,
		marginBottom: 20,
		marginLeft: -40,
		marginRight: -40,
	},
	selectors: {
		display: 'grid',
		gridTemplateColumns: 'auto auto',
		gridTemplateRows: '60px 60px 60px',
		justifyItems: 'center',
		margin: '20px auto',
	},
	socialMediaBannerContainer: {
		background: '#046cb6',
		borderRadius: 3,
		display: 'flex',
		height: 40,
		maxWidth: 470,
		...CssSelectors.allChildren({
			alignItems: 'center',
			color: 'white',
			display: 'flex',
			fontSize: 14,
			justifyContent: 'space-between',
			minWidth: 276,
			paddingRight: 20,
		}),
	},
	socialMediaContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-evenly',
		marginLeft: 10,
	},
	socialMediaPrompt: {
		color: '#0D0F11',
		fontSize: 14,
	},
	subjectFieldLabel: {
		display: 'block',
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
	subHeader: {
		color: charmGray,
		fontSize: 14,
		marginBottom: 12,
	},
	summaryTextField: {
		...CssSelectors.allChildren(
			{
				height: 80,
				resize: 'none',
			},
			'textarea'
		),
	},
	testSendContainer: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginRight: 10,
			},
			'.text-input'
		),
		':first-child': {
			...CssSelectors.allChildren(
				{
					marginRight: 10,
				},
				'button'
			),
		},
	},
	timeDropdownPlaceholder: {
		color: navigation,
	},
});
